import React from 'react';
import './TopNav.css';

function TopNav() {
  return (
    <div className='content'>
      <div className="left">
        <div className='left-1'>
        <li>Have any question?</li>
            <li><i className="icon fa fa-phone"></i><a href="#">021-34761999</a></li>
            <li><i className=" icon fa fa-envelope"></i><a href="#">info@sts.org.pk</a></li>
        </div>      
      </div>
      <div className="right">
            <div className="right-1">
                <li className='li-1 Top-N'><i className="icon Top-N fa fa-commenting"></i><a className='Top-N' href="#">CEO Message</a></li>
                <li className='st'>|</li>
                <li className='li-1 Top-N'><i className="icon Top-N fa fa-pencil-square-o"></i><a className='Top-N' href="#">0FAQ'S</a></li>
                <li className='st'>|</li>
                <li className='li-1 Top-N'><i className="icon Top-N fa fa-bell"></i><a className='Top-N' href="#">Complaint</a></li>
            </div>
      </div>
    </div>
  )
}

export default TopNav
